import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import LocalStorageUtil from '../../../util/LocalStorageUtil';
import { makeGetAvailableColors } from '../../../redux/product/selectors/ProductSelector';
import { SHOP_NUMBER_STORAGE_KEY } from '../../../constants/StorageKeysConstants';
import { isOneSizeProduct } from '@as-react/common-utils';
import { useAemConfig } from '@as-react/common-components';
import { StockAvailabilityPopupAlpha } from '../../stock-availability/StockAvailabilityPopupAlpha';
import { storeErpQueries } from '@as-react/common-queries';
import { useQuery } from '@tanstack/react-query';
const getProductSizes = (colorVariations) => {
    const sizes = new Map();
    colorVariations.forEach((productColor) => {
        if (productColor.sizes) {
            productColor.sizes.forEach((size) => {
                if (size.active && size.code) {
                    sizes.set(size.code, size);
                }
            });
        }
    });
    return Array.from(sizes.values()).sort((size, nextSize) => size.order - nextSize.order);
};
const parseStoreData = (storeStockData, productColors) => {
    var _a;
    const availability = [];
    (_a = storeStockData.colours) === null || _a === void 0 ? void 0 : _a.forEach((color) => { var _a; return (_a = color.sizes) === null || _a === void 0 ? void 0 : _a.forEach((size) => availability.push(size)); });
    return productColors.map((productColor) => {
        const color = {
            colorId: productColor.colorId,
            colorCode: productColor.colorCode,
            description: productColor.translations.description,
            swatch: productColor.swatch,
        };
        if (productColor.sizes) {
            const sizes = {};
            productColor.sizes.forEach((size) => {
                if (size.active) {
                    const availabilityBySku = availability.filter((avail) => String(avail.idSku) === String(size.sku))[0];
                    if (availabilityBySku && availabilityBySku.idSize) {
                        sizes[size.code] = availabilityBySku;
                    }
                }
            });
            color.sizes = sizes;
        }
        return color;
    });
};
export const StockAvailabilityAlpha = ({ productId, productCode, productBrand, productTitle, }) => {
    const { oneSizeProductCode, productImageConfig, defaultRequestParams, servicesEndpoint } = useAemConfig();
    const colors = useSelector(makeGetAvailableColors());
    const [selectedSku, setSelectedSku] = useState();
    const storeNumber = LocalStorageUtil.getJsonItem(SHOP_NUMBER_STORAGE_KEY);
    const productSizes = useMemo(() => getProductSizes(colors), [colors]);
    const { getProductAvailabilityForCurrentStore, getProductAvailabilityForAllStores } = storeErpQueries({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { data: currentStoreData } = useQuery(getProductAvailabilityForCurrentStore({ productId, storeNumber }, {
        enabled: !!storeNumber,
        select: data => parseStoreData(data, colors),
    }));
    const { data: allStoresData } = useQuery(getProductAvailabilityForAllStores({ skuId: selectedSku }, {
        enabled: !!selectedSku,
    }));
    if (!productSizes) {
        return null;
    }
    const handleCellClick = (sku) => {
        if (!sku || sku === selectedSku)
            return;
        setSelectedSku(sku);
    };
    return (_jsx(StockAvailabilityPopupAlpha, { productCode: productCode, productSizes: productSizes, selectedSku: selectedSku, currentStoreData: currentStoreData, allStoresData: allStoresData, isOneSizeProduct: isOneSizeProduct(productSizes, oneSizeProductCode), productImageCdnDomains: productImageConfig.cdnDomains, productBrand: productBrand, productTitle: productTitle, onCellClick: handleCellClick }));
};
